
import { defineComponent } from "vue";
import Grid from "@moonlight/vue3/components/Grid.vue";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import useAuthUser from "@/composables/useAuthUser";

export default defineComponent({
  components: {
    Grid,
    Header,
    Footer,
  },
  setup() {
    const { authUser, fetchAuthUser } = useAuthUser();
    fetchAuthUser();
    return {
      authUser,
    };
  },
});
